var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type === 'link'
            ? 'NuxtLink'
            : _vm.type === 'link-ext' || _vm.type === 'link-classic'
            ? 'a'
            : 'button',{tag:"component",class:[
        'a-button-circle',
        'cursor-[pointer_!important]',
        _vm.generateClassname,
        _vm.generateAfterClassname ],attrs:{"href":_vm.type === 'link-ext' || _vm.type === 'link-classic' ? _vm.href : null,"rel":_vm.type === 'link-ext' ? 'noopener' : null,"target":_vm.type === 'link-ext' ? '_blank' : null,"title":_vm.title,"to":_vm.type === 'link' ? _vm.localePath(_vm.href) : null,"type":_vm.type !== 'link' &&
        _vm.type !== 'link-ext' &&
        _vm.type !== 'link-classic' &&
        (_vm.type === 'button' || _vm.type === 'submit')
            ? _vm.type
            : null,"data-scroll":"","data-scroll-call":"cta","data-scroll-offset":"25%, 15%"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('BowIcons',{staticClass:"mr-3 z-1",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{class:[
            _vm.size === '2xs'
                ? 'text-sm leading-7'
                : 'text-sm sm:text-base leading-7',
            'text-center z-1' ]},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }